module.exports = __webpack_public_path__ + "media/2600_KMSAT45_2022_YRConclusion.644c26ce.mp4";